<div class="flex h-full w-full">
  <div class="box-border flex flex-1 flex-col gap-4 p-4 pe-0">
    <div class="flex shrink-0 flex-col gap-2 pe-4">
      <div class="flex items-center justify-between">
        <div class="typo-h2 ml-4 inline-flex text-text-primary">{{ 'charting_add_treatment_title' | translate }}</div>
        <button class="inline-flex" (click)="onCloseClick()">
          <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
        </button>
      </div>

      <div class="flex gap-2">
        <lib-input
          [value]="searchQuery()"
          [label]="'charting_add_treatment_search_placeholder' | translate"
          background="white"
          (valueChange)="onSearchQueryChange($event)"
        >
          <svg-icon class="text-text-tertiary" key="px-24-search" leftIcon></svg-icon>
        </lib-input>
        <lib-select-status [selectedStatus]="selectedStatus()" (statusChange)="onStatusChange($event)"></lib-select-status>
      </div>
    </div>

    <div class="-ml-4 flex flex-1 flex-col gap-4 overflow-hidden pl-4">
      <div class="-ml-4 flex min-h-0 flex-1 basis-full flex-wrap gap-4 pl-4">
        @if (classifications().state === DataState.Loading || (classifications().data ?? []).length > 0) {
          <div class="relative z-10 z-10 h-full w-[288px] overflow-hidden rounded-[32px] bg-background-white p-4 shadow-card">
            @if (classifications().state === DataState.Loading) {
              <ng-lottie
                currentcolor
                class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary-blue"
                [options]="lottieOptions"
              ></ng-lottie>
            } @else if (classifications().state === DataState.Fetched) {
              <lib-category-list class="h-full overflow-auto">
                @for (classification of classifications().data; track classification.classification) {
                  <lib-category-list-element
                    (click)="onClassificationClick(classification.classification)"
                    [active]="selectedClassification()?.classification === classification.classification"
                    [count]="classification.count"
                  >
                    {{ classification.classification }}
                  </lib-category-list-element>
                }
              </lib-category-list>
            }
          </div>

          <div
            class="relative -ml-12 box-border flex h-full flex-1 flex-col gap-3 overflow-auto rounded-br-4xl border-b-[2px] border-background-white pe-4 ps-12"
          >
            @if (classifications().state === DataState.Loading) {
              <ng-lottie
                currentcolor
                class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary-blue"
                [options]="lottieOptions"
              ></ng-lottie>
            } @else {
              @for (category of selectedClassification()?.categories; track category.name; let i = $index) {
                @if ((i === 0 || category.name !== selectedClassification()?.categories?.[i - 1]?.name) && category.name) {
                  <div class="flex items-center gap-2">
                    <div class="typo-h6-light-uppercase">
                      {{ category.name }}
                    </div>
                    <svg-icon
                      class="shrink-0 text-primary-blue"
                      key="px-16-info"
                      size="sm"
                      [libUiTooltip]="categoryTooltip"
                      tooltipPosition="bottom"
                    ></svg-icon>
                    <ng-template #categoryTooltip>
                      <div class="typo-h5-book">
                        {{ category.description }}
                      </div>
                    </ng-template>
                  </div>
                }
                <div class="flex flex-col gap-2">
                  @for (treatment of category.treatments; track treatment.dentalCode) {
                    <lib-treatment-element [treatment]="treatment" (addTreatment)="onAddTreatment($event)" />
                  }
                </div>
              }
            }
          </div>
        } @else {
          <div class="flex h-full w-full flex-col items-center justify-center gap-2 text-text-light">
            <p class="typo-h4-semibold">{{ 'charting_treatment_plan_no_treatment_title' | translate }}</p>
            <p class="typo-h5-book">{{ 'charting_treatment_plan_no_treatment_subtitle' | translate }}</p>
          </div>
        }
      </div>

      <!-- TRAY -->
      @if (addedTreatments().length > 0) {
        <lib-treatment-tray [addedTreatments]="addedTreatments()"></lib-treatment-tray>
      }

      <!-- FOOTER -->
      <div class="flex justify-between gap-4">
        <button class="btn-text px-6" (click)="onCloseClick()">{{ 'charting_add_treatment_cancel_button' | translate }}</button>
        <div class="flex gap-6">
          <div class="flex max-h-[42px] flex-1 justify-between gap-4 self-end pe-4">
            <lib-select-provider
              [defaultValue]="currentProvider()"
              [noResultLabel]="'schedule_details_appointment_no_providers' | translate"
              [transparentBackground]="true"
              [label]="'charting_add_treatment_provider_label' | translate"
              [dynamicHeight]="false"
              [openToTop]="true"
              (itemSelected)="onProviderChange($event)"
            />

            <div class="mx-10 h-8 w-[2px] bg-background-white"></div>
            <button
              class="btn-primary shadow-none"
              [disabled]="applyButtonDisabled()"
              (click)="onApplyClick()"
              [ffdPushTagOnClick]="{
                event: TagEvent.ChartingTreatmentAdded
              }"
              [libUiTooltip]="applyButtonTooltip"
              tooltipPosition="top"
            >
              {{ 'charting_add_treatment_apply_treatments_button' | translate }}
            </button>
          </div>
          @if (!isAddTreatmentEnabled()) {
            <ng-template #applyButtonTooltip>
              <div class="typo-h5-book p-2">
                {{ 'charting_add_treatment_button_disabled_warning' | translate }}
              </div>
            </ng-template>
          }
        </div>
      </div>
    </div>
  </div>
</div>
